
import React, { useState } from 'react';
import { Mail, Phone, Clock, MapPin, Send } from 'lucide-react';
import './contact.css'
const Contact = () => {
    // // State for form inputs (unchanged)
    // const [formData, setFormData] = useState({
    //     firstName: '',
    //     lastName: '',
    //     email: '',
    //     phone: '',
    //     message: '',
    // });
    // const [isSubmitting, setIsSubmitting] = useState(false);
    // const [submissionStatus, setSubmissionStatus] = useState(null);

    // const handleChange = (e) => {
    //     setFormData({ ...formData, [e.target.name]: e.target.value });
    //     if (submissionStatus) setSubmissionStatus(null);
    // };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     setIsSubmitting(true);
    //     setSubmissionStatus(null);

    //     // Simulate an API call
    //     setTimeout(() => {
    //         setIsSubmitting(false);
    //         console.log('Form data submitted:', formData);
    //         setSubmissionStatus('success');
    //         setFormData({
    //             firstName: '',
    //             lastName: '',
    //             email: '',
    //             phone: '',
    //             message: '',
    //         });
    //     }, 1500);
    // };



    return (
        <>
            {/* This is an embedded <style> block containing all the necessary CSS. 
        It allows the use of classic CSS classes within the single React file.
      */}


            <div className="contact-page-container">
                {/* Central Content Introduction */}
                <div className="intro-section">
                    <h1 className="intro-title">
                        Let's Start a <span className="accent-text">Conversation</span>
                    </h1>
                    <p className="intro-text">
                        We're here to help with all your cleaning product needs. Get in touch and
                        let's discuss how we can serve you better.
                    </p>
                </div>

                {/* Main Contact Content Layout */}
                <div className="main-content-grid">

                    {/* --- Left Column: Get in Touch --- */}
                    <div className="left-column">
                        <h2 className="section-heading">Get in Touch</h2>
                        <p className="section-description">
                            Ready to experience the difference our premium cleaning products can
                            make? We'd love to hear from you.
                        </p>

                        <div className="details-card">
                            {/* Email */}
                            <div className="contact-detail">
                                <Mail size={20} />
                                <div>
                                    <h4>Email Address</h4>
                                    <p>Our team is here to help at all times.</p>
                                    <p>ouremail@gmail.com</p>
                                </div>
                            </div>

                            {/* Phone */}
                            <div className="contact-detail">
                                <Phone size={20} />
                                <div>
                                    <h4>Phone Number</h4>
                                    <p>Call us during business hours.</p>
                                    <p>+91 98673 78209</p>
                                </div>
                            </div>

                            {/* Business Hours */}
                            <div className="contact-detail">
                                <Clock size={20} />
                                <div>
                                    <h4>Business Hours</h4>
                                    <p>Monday to Sunday</p>
                                    <p>08:00 AM to 10:00 PM</p>
                                </div>
                            </div>

                            {/* Office Location */}
                            <div className="contact-detail">
                                <MapPin size={20} />
                                <div>
                                    <h4>Office Location</h4>
                                    <p> A, Yogi Executive Hotel, 4, MAFCO MARKET, Sector 18, Vashi</p>
                                    <p> Navi Mumbai, Maharashtra 400703</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* --- Right Column: Send us a Message (Form) --- */}
                    <div className="form-card">
                        <div className="form-padding">
                            <div className='sendMsg'>
                                <h2 className="form-heading">Send us a Message</h2>
                                <p className="form-description">
                                    We'll get back to you within 24 hours.
                                </p>
                            </div>
                            <form className="form-layout">

                                <div className="input-row">
                                    <label htmlFor="firstName" className="form-label">First Name *</label>
                                    <label htmlFor="firstName" className="form-label ">Last Name *</label>

                                    {/* First Name */}
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        placeholder="Your First Name"
                                        // value={formData.firstName}
                                        required
                                        className="form-input"
                                    />
                                    {/* Last Name */}
                                    <input
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        placeholder="Your Last Name"
                                        // value={formData.lastName}
                                        // onChange={handleChange}
                                        required
                                        className="form-input"
                                    />
                                </div>
                                <div className="input-row">
                                    <label htmlFor="email" className="form-label">Email *</label>
                                    <label htmlFor="phone" className="form-label">Phone</label>
                                    {/* Email Address */}
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="your.email@example.com"
                                        // value={formData.email}
                                        // onChange={handleChange}
                                        required
                                        className="form-input"
                                    />
                                    {/* Phone Number */}
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        placeholder="+91 9833615161"
                                        // value={formData.phone}
                                        // onChange={handleChange}
                                        className="form-input"
                                    />
                                </div>

                                {/* Password field */}
                                <div className="input-row">
                                    <label htmlFor="password" className="form-label">Password *</label>
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        placeholder="Your Password"
                                        // value={formData.password || ''}
                                        // onChange={handleChange}
                                        required
                                        className="form-input form-input-span-2"
                                    />
                                </div>

                                {/* Message */}
                                <label htmlFor="message" className="form-label">Your Message *</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    placeholder="Your Message*"
                                    // value={formData.message}
                                    // onChange={handleChange}
                                    rows="4"
                                    required
                                    className="form-textarea"
                                ></textarea>

                                {/* Submission Status Message Box */}
                                {/* {submissionStatus === 'success' && (
                                    <div className="success-message">
                                        <span role="img" aria-label="success">✅</span> Message sent successfully! We will contact you soon.
                                    </div>
                                )}
                                {submissionStatus === 'error' && (
                                    <div className="error-message">
                                        <span role="img" aria-label="error">❌</span> Failed to send message. Please try again.
                                    </div>
                                )} */}

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    // disabled={isSubmitting}
                                    className="submit-button"
                                >
                                    {/* {isSubmitting ? (
                                        <svg className="spinner -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <> */}
                                    <Send size={20} className="mr-2" /> Send Message
                                    {/* </>
                                    )} */}
                                </button>
                            </form>

                            <p className="form-footer-text">
                                *Required field. We respect your privacy and will never share your information.
                            </p>
                        </div>
                    </div>


                </div>
            </div>
        </>
    );
};

export default Contact;
